import HostApi from "../../../../settings/HostApi";
import { Either, right, left } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";

//TODO API
const SignOutApiImpl = async (): Promise<Either<ExceptionEntity, void>> => {
    const relativeUrl = "";
    try {
        HostApi.removeToken();
        HostApi.removeEmail();
        return right(undefined);
    } catch (error) {
        return left({});
    }
};

export default SignOutApiImpl;
